import { render, staticRenderFns } from "./SysAccMan.vue?vue&type=template&id=ff255e0a&scoped=true"
import script from "./SysAccMan.vue?vue&type=script&lang=js"
export * from "./SysAccMan.vue?vue&type=script&lang=js"
import style0 from "./SysAccMan.vue?vue&type=style&index=0&id=ff255e0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff255e0a",
  null
  
)

export default component.exports